import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { getCurrentPlan, getTrialList, getUserPricingPackages } from './thunk'

const initialState = {
  dataCurrentPlan: [],
  dataPricingPackage: [],
  loading: {
    currentPlan: true,
    pricingPackage: true,
    trialList: true,
  },
  dataTrialList: {},
  ids: [],
  filterTrial: {
    page: 1,
    pageSize: 10,
  },
  totalRecordsTrial: 0,
}

const slice = createSlice({
  name: 'dashboard/currentPlan',
  initialState,
  reducers: {
    changeFilterTrial: (state, action) => {
      state.filterTrial = {
        ...state.filterTrial,
        ...action.payload,
      }
    },
  },
  extraReducers: (builder) => {
    //getCurrentPlan
    builder.addCase(getCurrentPlan.pending, (state, action) => {
      state.loading.currentPlan = true
    })
    builder.addCase(getCurrentPlan.fulfilled, (state, action) => {
      state.dataCurrentPlan = action.payload
      state.loading.currentPlan = false
    })
    builder.addCase(getCurrentPlan.rejected, (state, action) => {
      state.loading.currentPlan = action.payload.loading
    })
    //getUserPricingPackages
    builder.addCase(getUserPricingPackages.pending, (state) => {
      state.loading.pricingPackage = true
    })
    builder.addCase(getUserPricingPackages.fulfilled, (state, action) => {
      state.dataPricingPackage = action.payload
      // state.dataPricingPackage = faker
      state.loading.pricingPackage = false
    })
    builder.addCase(getUserPricingPackages.rejected, (state, action) => {
      state.loading.pricingPackage = action.payload.loading
    })
    //getTrialList
    builder.addCase(getTrialList.pending, (state) => {
      state.loading.trialList = true
    })
    builder.addCase(getTrialList.fulfilled, (state, { payload = {} }) => {
      const formatData = (payload.data || []).map((item) => ({
        ...item,
        orgValue: {
          organizationName: item?.organizationName,
          organizationId: item?.organizationId,
        },
      }))

      state.dataTrialList = keyBy(formatData, 'organizationId')
      state.totalRecordsTrial = payload?.totalRecords
      state.ids = Object.keys(state.dataTrialList)
      state.loading.trialList = false
    })
    builder.addCase(getTrialList.rejected, (state, action) => {
      state.loading.trialList = action.payload.loading
    })
  },
})

export const loadingCurrentPlan = (type) => (state) =>
  state[slice.name].loading[type]

export const getDataCurrentPlan = (state) => state[slice.name].dataCurrentPlan
export const getDataPackage = (state) => state[slice.name].dataPricingPackage

//table
export const getDataFromReduxTrialList = (rowId, colId) => (state) =>
  state[slice.name].dataTrialList[rowId][colId]
export const idsTableTrialList = (state) => state[slice.name].ids
export const selectTotalTrial = (state) => state[slice.name].totalRecordsTrial
export const selectFilterTrial = (state) => state[slice.name].filterTrial

export const { changeFilterTrial } = slice.actions

register(slice.name, slice.reducer)
